import React, { useContext, useEffect, useRef, useState } from "react";
import "./LinkUnavailable.css";
// import OrderSubtitle from "./Components/OrderSubtitle/OrderSubtitle";
import UniversalCheckoutHeader from "../../UniversalComponents/CheckoutHeader/CheckoutHeader";
import { useNavigate } from "react-router-dom";
import { ItemDetailsData } from "../../Utils/DefinitionsInterfaces";
import {
  fetchItemDetails,
  getSchoolByCode,
  verifyNFOTransaction,
} from "../../Utils/CheckoutAPIs/CheckoutAPIs";
import CheckoutFooter from "../ComponentsCheckoutPage/Components/CheckoutFooter/CheckoutFooter";
import { CircularProgress } from "@mui/material";
import axios from "axios";
import { error } from "console";

const LinkUnavailable = () => {
  // const isApiCallNeededRef = useRef<boolean>(false);
  const urlParams = new URLSearchParams(window.location.search);
  const orderId = urlParams.get("order_id");
  const itemIds = urlParams.get("item_ids");
  const schoolCode = urlParams.get("scl");
  // const [cartResetNeeded, setCartResetNeeded] = useState(true);

  const [pageLoading, setLoading] = useState(true);
  const [schoolName, setSchoolName] = useState("");

  const verifyLink = (sclCode: string) => {
    getSchoolByCode(sclCode)
      .then((schoolDetails) => {
        if (schoolDetails.linkActive !== false) {
          navigate(`/CheckoutPage/`);
        } else {
          setSchoolName(schoolDetails.schoolName);
        }
      })
      .catch((error) => {
        navigate(`/CheckoutPage/`);
      });
    setLoading(false);
  };

  useEffect(() => {
    // fetchItemsList();
    setLoading(true);
    if (schoolCode) {
      verifyLink(schoolCode);
    } else {
      navigate(`/CheckoutPage/`);
    }
    // const handleBeforeUnload = (event: BeforeUnloadEvent): void => {
    //   // Prompt the user before they leave the page
    //   event.preventDefault();
    //   event.returnValue = ""; // Required for Chrome
    //   sessionStorage.setItem("nfoCheckoutIsApiCallNeeded", "true");
    // };

    // window.addEventListener("beforeunload", handleBeforeUnload);

    // const nfoCheckoutIsApiCallNeeded = sessionStorage.getItem(
    //   "nfoCheckoutIsApiCallNeeded"
    // );
    // if (
    //   nfoCheckoutIsApiCallNeeded &&
    //   nfoCheckoutIsApiCallNeeded !== "" &&
    //   nfoCheckoutIsApiCallNeeded === "false"
    // ) {
    //   console.log("No need of api call");
    // } else {
    //   console.log("Item Ids from url = ", itemIds);
    //   if (itemIds && itemIds.length > 0) {
    //     //&& !Number.isNaN(cartItemId)) {
    //     let itemsIdsAr: number[] = [];
    //     itemsIdsAr = itemIds.split("-").map(Number);
    //     populateItemDetails(itemsIdsAr);
    //     setCartResetNeeded(false);
    //     sessionStorage.setItem("nfoCheckoutIsApiCallNeeded", "false");
    //   }
    // }

    // return () => {
    //   window.removeEventListener("beforeunload", handleBeforeUnload);
    // };
    // return () => {
    //   sessionStorage.clear();
    // };
  }, []);

  // useEffect(() => {
  //   const nfoCheckoutIsApiCallNeeded = sessionStorage.getItem(
  //     "nfoCheckoutIsApiCallNeeded"
  //   );
  //   if (
  //     nfoCheckoutIsApiCallNeeded &&
  //     nfoCheckoutIsApiCallNeeded !== "" &&
  //     nfoCheckoutIsApiCallNeeded === "false"
  //   ) {
  //     console.log("No need of api call");
  //   } else {
  //     console.log("Item Ids from url = ", itemIds);
  //     if (itemIds && itemIds.length > 0) {
  //       //&& !Number.isNaN(cartItemId)) {
  //       let itemsIdsAr: number[] = [];
  //       itemsIdsAr = itemIds.split("-").map(Number);
  //       populateItemDetails(itemsIdsAr);
  //       setCartResetNeeded(false);
  //       sessionStorage.setItem("nfoCheckoutIsApiCallNeeded", "false");
  //     }
  //   }
  // }, [stateItemId]);

  // const itemId = localStorage.getItem("itemId");
  // const itemId = sessionStorage.getItem("itemId");

  // const [cartItemId, setCartItemId] = useState(
  //   parseInt(itemId as unknown as string)
  // );

  const navigate = useNavigate();

  // const populateItemDetails = async (itemIds: number[]): Promise<void> => {
  //   let foundItems: ItemDetailsData[] = [];
  //   for (let i = 0; i < itemIds.length; i++) {
  //     const foundItem = await fetchItemDetails(itemIds[i]);
  //     foundItems.push(foundItem[0]);
  //   }
  //   let numOrderItems = foundItems.length;

  //   let presArItems: ItemDetailsData[] = structuredClone(checkoutItems);
  //   console.log(foundItems);
  //   let isStateUpdateNeeded = true;
  //   if (presArItems.sort().join(",") === foundItems.sort().join(",")) {
  //     isStateUpdateNeeded = false;
  //   }

  //   if (isStateUpdateNeeded) setCheckoutItems(foundItems);
  // };

  return pageLoading ? (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        width: "100vw",
      }}
    >
      <CircularProgress />
    </div>
  ) : (
    <div className="link-unavailable-page">
      <UniversalCheckoutHeader />
      <div className="link-unavailable-title">
        Registrations for {schoolName} are now closed.
        <br />
        For further assistance, please contact your school authorities.
      </div>
      {/* <div className="checkout-footer-wrapper">
        <CheckoutFooter />
      </div> */}
    </div>
  );
};

export default LinkUnavailable;
